<template>
    <div class="uk-flex uk-flex-column uk-flex-center ">
        <div>
            <div class="uk-card uk-card-default uk-card-large uk-card-body uk-text-center">
                <v-icon color="#333333" x-large>mdi-alert-circle-outline</v-icon>
                <h1>Page not found</h1>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "PageNotFound"
    }
</script>

<style scoped>

</style>